import { CurrencyPipe, isPlatformBrowser, NgFor, NgForOf, NgIf } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, inject, PLATFORM_ID, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { StrapiService } from 'app/core/shared-services/strapi.service';
import { FooterComponent } from '../../landing/footer/footer.component';
import { ProductFaqComponent } from '../../product-faq/product-faq.component';
import { Router, RouterLink } from '@angular/router';
import { FuseCardComponent } from '@fuse/components/card';
import { SharedMethodsModule } from 'app/core/shared-services/shared-methods.module';
import { Package } from 'app/core/shared-services/shared-interface.types';
import { MatSelectModule } from '@angular/material/select';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { MatPaginator, MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { SwiperPackagesComponent } from 'app/modules/dashboard/package-options/swiper-packages/swiper-packages.component';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import { Subject, takeUntil } from 'rxjs';
import { InnerHTMLPipe } from 'app/core/pipes/innerHTML.pipe';
import { BoldKeywordsPipe } from 'app/core/pipes/boldKeywordspipe';
import { GtmService } from 'app/core/shared-services/gtm.service';
@Component({
  standalone: true,
  selector: 'fiveg ',
  templateUrl: './fixed-lte.component.html',
  styleUrls: ['./fixed-lte.component.scss'],
  imports: [MatButtonModule, RouterLink, MatIconModule, NgForOf, NgFor, NgIf, FooterComponent, RouterLink,ProductFaqComponent, FuseCardComponent,
     CurrencyPipe, MatSelectModule, NgxSkeletonLoaderModule, MatPaginatorModule, MatFormFieldModule, MatDividerModule, SwiperPackagesComponent, InnerHTMLPipe, BoldKeywordsPipe]
})
export class FixedLTE {

  @ViewChild(MatPaginator, { static: false }) matPaginator: MatPaginator;


  public headerImage: string;
  public headerTitle: string;
  public headerTextColor: string;
  public description: any;
  public products: Array<Package> = [];
  public filteredProducts: any = [];
  public loading: boolean = true;
  public pagedProducts: any = [];
  public totalProducts: number;
  public pageSize: number = 6;
  public providers = new Set();
  public showSwiper: boolean = false;
 
  private isScreenSmall: boolean;
  private _unsubscribeAll: Subject<any> = new Subject<any>();

  private referrer: string;

  // ## DEPENDENCIES ##
  private _strapiService = inject(StrapiService);
  private _sharedMethods = inject(SharedMethodsModule);
  private changeDetector = inject(ChangeDetectorRef);
  private _fuseMediaWatcherService = inject(FuseMediaWatcherService);
  private _gtmService = inject(GtmService)
  private router = inject(Router)

  constructor(
    @Inject(PLATFORM_ID) private platformId: any
  ){}

  
  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------
  /**
   * On init
   */
  ngOnInit(): void {

    if (isPlatformBrowser(this.platformId)) {

      if(localStorage.getItem('currentURL')) {
        if(localStorage.getItem('currentURL') == window.location.href) {
          //this.referrer = window.location.href
        } else {
          this.referrer = localStorage.getItem('currentURL')
          localStorage.setItem('currentURL', window.location.href);
          localStorage.setItem('previousURL', this.referrer);
        }
      } else {
        localStorage.setItem('currentURL', window.location.href);
      }

      const route = window.location.href;
      const path = this.router.url;
      this._gtmService.pushEvent({ 
        event: 'page_view',
        page_url: route,
        page_path: path,
        page_title: 'fixed_lte_page',
        page_referrer: this.referrer ? this.referrer : route
      });
    }

    // Subscribe to media changes
    this._fuseMediaWatcherService.onMediaChange$
    .pipe(takeUntil(this._unsubscribeAll))
    .subscribe(({matchingAliases}) =>
    {
        // Check if the screen is small
        this.isScreenSmall = !matchingAliases.includes('md');
    });
    
    this._strapiService.GetProductsContent()
      .subscribe({
        next: (res: any) => {
          res.data.forEach(item => {
            if (item.name === "Fixed-LTE") {
              this.headerTitle = item.headerText;
              if(this.isScreenSmall) {
                this.headerImage = item.mobileImage.url;
              } else {
                this.headerImage = item.headerImage.url;
              }
              this.description = item.description;
              this.headerTextColor = item?.text_color_hex;
            }
          });
          this.loading = false;
        }
      });
    this.getAllPackages();
  }

  ngAfterViewInit() {
    if (this.matPaginator) {
      this.matPaginator?.firstPage();
    }
  }

  public pageEvent(event: PageEvent) {
    this.setPagedProducts(event.pageIndex, event.pageSize);
  }

  public setPagedProducts(pageIndex: number, pageSize: number) {
    const start = pageIndex * pageSize;
    const end = start + pageSize;
    this.pagedProducts = this.filteredProducts.slice(start, end);
  }

  public onProviderSelect(provider: string) {
    this.showSwiper = false;
    this.changeDetector.detectChanges();
    this.filteredProducts = [];
    
    const sortedProducts = this.products.sort((a, b) => a.totalRecurring - b.totalRecurring);
    sortedProducts.forEach(product => {
      if (provider === product.PackageSupplierOrganisationEntity || provider === "All Providers") {
        this.filteredProducts.push(product);
      }
    });
  
    this.totalProducts = this.filteredProducts.length;
    this.setPagedProducts(0, 6);
    this.showSwiper = true;
  }

  private getAllPackages() {
    let filteredByTagProducts = []; 
    this._sharedMethods.getAllPackages().then((res) => {
      this.products = res.result?.filter((element: any) => element.OfferableSubTypeCode == 'Service:Internet:FLTE' && element.Audit_IsActive)
        .map((element: any) => ({
          packageEntityID: element.PackageEntityID,
          packageName: element.PackageName,
          totalRecurring: element.TotalRecurring,
          packageDescription: element.PackageDescription,
          packageCategoryTypeCode: element.PackageCategoryTypeCode,
          PackageSupplierOrganisationEntity: element.PackageSupplierOrganisationEntity,
          Tags: element?.Tags,
          MbpsDownload: element?.MbpsDownload,
          MbpsUpload: element?.MbpsUpload,
          UpfrontBenefits: element.UpfrontBenefits
        } as Package));
        if (Array.isArray(this.products)) {
          this.products.forEach(el => {
            this.products = [];
            if (el.Tags) {
              el.Tags.forEach(t => {
                if (t.TagName == 'Active Offer') {
                  filteredByTagProducts.push(el)
                }
              })
            }
          })
        this.products = filteredByTagProducts;
        this.filterProviders(filteredByTagProducts);
        this.onProviderSelect("All Providers");
        }
    });
  }

  private filterProviders(products: Package[]): any[] {
    this.providers.add("All Providers");
    return products.filter(product => {
      if (product.PackageSupplierOrganisationEntity && !this.providers.has(product.PackageSupplierOrganisationEntity)) {
        this.providers.add(product.PackageSupplierOrganisationEntity);
      }
    });
  }

   /**
     * On destroy
     */
   ngOnDestroy(): void
   {
       // Unsubscribe from all subscriptions
       this._unsubscribeAll.next(null);
       this._unsubscribeAll.complete();
   }
  
}





